<script module lang="ts">
  export {
    IconMenu,
    IconGitHub,
    IconCommandPalette,
    IconSettings,
    IconLucideTextSelect,
    IconTablerStar,
    IconTablerArrowUp,
    IconTablerArrowDown,
    IconTablerLetterCase,
    IconTablerSelectAll,
    IconTablerChevronDown,
    IconTablerChevronUp,
    IconTablerChevronRight,
    IconTablerX,
    IconTablerReplace,
    IconTablerReplaceFilled,
    IconFluentWholeWord,
    IconTablerRegex,
    IconLucideType,
    IconLucideReplace,
    IconLucideReplaceAll,
    IconTablerLayoutSidebarLeftExpand,
    IconTablerLayoutSidebarLeftCollapse,
    IconTablerPlus,
    IconMdiArrowCollapseLeft,
    IconMdiArrowCollapseRight,
    IconTablerTrash,
    IconTablerArchive,
    IconGrokIconDown,
    IconTablerHome,
  };
</script>

<!--
Icon from Material Design Icons by Pictogrammers - https://github.com/Templarian/MaterialDesign/blob/master/LICENSE

https://icones.js.org/collection/all?s=collapse&icon=mdi:arrow-collapse-right
-->
{#snippet IconMdiArrowCollapseRight()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      d="M12.08 4.08L20 12l-7.92 7.92l-1.41-1.42l5.5-5.5H2v-2h14.17l-5.5-5.5zM20 12v10h2V2h-2z"
    /></svg
  >
{/snippet}

<!--
Icon from Material Design Icons by Pictogrammers - https://github.com/Templarian/MaterialDesign/blob/master/LICENSE

https://icones.js.org/collection/all?s=collapse&icon=mdi:arrow-collapse-left
-->
{#snippet IconMdiArrowCollapseLeft()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      d="M11.92 19.92L4 12l7.92-7.92l1.41 1.42l-5.5 5.5H22v2H7.83l5.51 5.5zM4 12V2H2v20h2z"
    /></svg
  >
{/snippet}

{#snippet IconMenu()}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 6l16 0" />
    <path d="M4 12l16 0" />
    <path d="M4 18l16 0" />
  </svg>
{/snippet}}

{#snippet IconGitHub()}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path
      d="M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5"
    >
    </path>
  </svg>
{/snippet}

{#snippet IconCommandPalette()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M3.045 18.894L9.94 12L3.045 5.106a.75.75 0 0 1 1.06-1.061l7.425 7.425a.75.75 0 0 1 0 1.06l-7.424 7.425a.75.75 0 0 1-1.061-1.06Zm8.205.606a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5z"
    />
  </svg>
{/snippet}

{#snippet IconSettings()}
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 512 512"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M262.29 192.31a64 64 0 1 0 57.4 57.4 64.13 64.13 0 0 0-57.4-57.4ZM416.39 256a154.34 154.34 0 0 1-1.53 20.79l45.21 35.46a10.81 10.81 0 0 1 2.45 13.75l-42.77 74a10.81 10.81 0 0 1-13.14 4.59l-44.9-18.08a16.11 16.11 0 0 0-15.17 1.75A164.48 164.48 0 0 1 325 400.8a15.94 15.94 0 0 0-8.82 12.14l-6.73 47.89a11.08 11.08 0 0 1-10.68 9.17h-85.54a11.11 11.11 0 0 1-10.69-8.87l-6.72-47.82a16.07 16.07 0 0 0-9-12.22 155.3 155.3 0 0 1-21.46-12.57 16 16 0 0 0-15.11-1.71l-44.89 18.07a10.81 10.81 0 0 1-13.14-4.58l-42.77-74a10.8 10.8 0 0 1 2.45-13.75l38.21-30a16.05 16.05 0 0 0 6-14.08c-.36-4.17-.58-8.33-.58-12.5s.21-8.27.58-12.35a16 16 0 0 0-6.07-13.94l-38.19-30A10.81 10.81 0 0 1 49.48 186l42.77-74a10.81 10.81 0 0 1 13.14-4.59l44.9 18.08a16.11 16.11 0 0 0 15.17-1.75A164.48 164.48 0 0 1 187 111.2a15.94 15.94 0 0 0 8.82-12.14l6.73-47.89A11.08 11.08 0 0 1 213.23 42h85.54a11.11 11.11 0 0 1 10.69 8.87l6.72 47.82a16.07 16.07 0 0 0 9 12.22 155.3 155.3 0 0 1 21.46 12.57 16 16 0 0 0 15.11 1.71l44.89-18.07a10.81 10.81 0 0 1 13.14 4.58l42.77 74a10.8 10.8 0 0 1-2.45 13.75l-38.21 30a16.05 16.05 0 0 0-6.05 14.08c.33 4.14.55 8.3.55 12.47Z"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32px"
    ></path>
  </svg>
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna - https://github.com/tabler/tabler-icons/blob/master/LICENSE
https://icones.js.org/collection/tabler?s=archive&icon=tabler:trash
-->

{#snippet IconTablerTrash()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M4 7h16m-10 4v6m4-6v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"
    /></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna - https://github.com/tabler/tabler-icons/blob/master/LICENSE
https://icones.js.org/collection/tabler?s=archive&icon=tabler:archive
-->
{#snippet IconTablerArchive()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2m2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8m-9 4h4"
    /></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna - https://github.com/tabler/tabler-icons/blob/master/LICENSE
https://icones.js.org/collection/tabler?s=plus&icon=tabler:plus
-->
{#snippet IconTablerPlus()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M12 5v14m-7-7h14"
    /></svg
  >
{/snippet}
<!--
Icon from Tabler Icons by Paweł Kuna - https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/tabler?s=left&icon=tabler:layout-sidebar-left-expand
-->
{#snippet IconTablerLayoutSidebarLeftExpand()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
      ><path d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm5-2v16" /><path
        d="m14 10l2 2l-2 2"
      /></g
    ></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna - https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/tabler?s=left&icon=tabler:layout-sidebar-left-collapse
-->
{#snippet IconTablerLayoutSidebarLeftCollapse()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
      ><path d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm5-2v16" /><path
        d="m15 10l-2 2l2 2"
      /></g
    ></svg
  >
{/snippet}
<!--
Icon from Tabler Icons by Paweł Kuna
https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/tabler?s=arrow+up&icon=tabler:star
-->
{#snippet IconTablerStar(fill = "none", klass = "")}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" class={klass}
    ><path
      {fill}
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="m12 17.75l-6.172 3.245l1.179-6.873l-5-4.867l6.9-1l3.086-6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
    /></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna
https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/tabler?s=arrow+up&icon=tabler:arrow-up
-->
{#snippet IconTablerArrowUp()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M12 5v14m6-8l-6-6m-6 6l6-6"
    /></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna
https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/tabler?s=arrow+up&icon=tabler:arrow-down
-->

{#snippet IconTablerArrowDown()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M12 5v14m6-6l-6 6m-6-6l6 6"
    /></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna
https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/tabler?s=case&icon=tabler:letter-case
-->

{#snippet IconTablerLetterCase()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M14 15.5a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0-7 0M3 19V8.5a3.5 3.5 0 0 1 7 0V19m-7-6h7m11-1v7"
    /></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna
https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/tabler?s=select&icon=tabler:select-all
-->
{#snippet IconTablerSelectAll()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M8 9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zm4 11v.01m4-.01v.01M8 20v.01M4 20v.01M4 16v.01M4 12v.01M4 8v.01M4 4v.01M8 4v.01M12 4v.01M16 4v.01M20 4v.01M20 8v.01M20 12v.01M20 16v.01M20 20v.01"
    /></svg
  >
{/snippet}

<!--
Icon from Lucide by Lucide Contributors - https://github.com/lucide-icons/lucide/blob/main/LICENSE
https://icones.js.org/collection/all?s=text-select&icon=lucide:text-select
-->
{#snippet IconLucideTextSelect()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M5 3a2 2 0 0 0-2 2m16-2a2 2 0 0 1 2 2m0 14a2 2 0 0 1-2 2M5 21a2 2 0 0 1-2-2M9 3h1M9 21h1m4-18h1m-1 18h1M3 9v1m18-1v1M3 14v1m18-1v1M7 8h8m-8 4h10M7 16h6"
    /></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna
https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/tabler?s=select&icon=tabler:chevron-down
-->
{#snippet IconTablerChevronDown()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="m6 9l6 6l6-6"
    /></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna
https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/tabler?s=select&icon=tabler:chevron-up
-->
{#snippet IconTablerChevronUp()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="m6 15l6-6l6 6"
    /></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna
https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/tabler?s=select&icon=tabler:chevron-right
-->
{#snippet IconTablerChevronRight()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="m9 6l6 6l-6 6"
    /></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna
https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/tabler?s=select&icon=tabler:x
-->
{#snippet IconTablerX()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M18 6L6 18M6 6l12 12"
    /></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna
https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/tabler?s=replace&icon=tabler:replace
-->

{#snippet IconTablerReplace()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M3 4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm12 12a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm6-5V8a2 2 0 0 0-2-2h-6l3 3m0-6l-3 3M3 13v3a2 2 0 0 0 2 2h6l-3-3m0 6l3-3"
    /></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna
https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/tabler?s=replace&icon=tabler:replace-filled
-->
{#snippet IconTablerReplaceFilled()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="currentColor"
      d="M8 2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m12 12h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2M16.707 2.293a1 1 0 0 1 .083 1.32l-.083.094L15.414 5H19a3 3 0 0 1 2.995 2.824L22 8v3a1 1 0 0 1-1.993.117L20 11V8a1 1 0 0 0-.883-.993L19 7h-3.585l1.292 1.293a1 1 0 0 1-1.32 1.497l-.094-.083l-3-3a.98.98 0 0 1-.28-.872l.036-.146l.04-.104q.087-.191.245-.334l2.959-2.958a1 1 0 0 1 1.414 0M3 12a1 1 0 0 1 .993.883L4 13v3a1 1 0 0 0 .883.993L5 17h3.585l-1.292-1.293a1 1 0 0 1-.083-1.32l.083-.094a1 1 0 0 1 1.32-.083l.094.083l3 3a.98.98 0 0 1 .28.872l-.036.146l-.04.104a1 1 0 0 1-.245.334l-2.959 2.958a1 1 0 0 1-1.497-1.32l.083-.094L8.584 19H5a3 3 0 0 1-2.995-2.824L2 16v-3a1 1 0 0 1 1-1"
    /></svg
  >
{/snippet}

<!--
Icon from Fluent UI System Icons by Microsoft Corporation - https://github.com/microsoft/fluentui-system-icons/blob/main/LICENSE

https://icones.js.org/collection/fluent?s=whole-word&icon=fluent:text-whole-word-16-regular
-->
{#snippet IconFluentWholeWord()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M10 2a.5.5 0 0 0-1 0v9.5a.5.5 0 0 0 1 0v-.1c.418.377.937.6 1.5.6c1.381 0 2.5-1.343 2.5-3s-1.119-3-2.5-3c-.563 0-1.082.223-1.5.6zm3 7c0 1.283-.835 2-1.5 2S10 10.283 10 9s.835-2 1.5-2s1.5.717 1.5 2M7 7.834l-.003-.137c-.054-1.212-.832-1.963-2.139-2.028l-.191-.007c-.753-.014-1.35.122-1.789.43a.499.499 0 1 0 .574.818c.264-.185.715-.275 1.356-.243c.82.041 1.184.406 1.191 1.144a5 5 0 0 0-1.893-.14C2.792 7.83 2 8.684 2 9.834c0 1.304.941 2.167 2.167 2.167c.565 0 1.174-.193 1.833-.57v.07l.005.068a.5.5 0 0 0 .495.432l.068-.005A.5.5 0 0 0 7 11.509zm-2.774.854a4 4 0 0 1 1.571.128v.001l.202.06v1.393l-.165.113c-.656.432-1.214.642-1.668.642c-.692 0-1.167-.436-1.167-1.167c0-.633.405-1.07 1.227-1.17M16 13.5V13a.5.5 0 1 0-1 0v.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V13a.5.5 0 1 0-1 0v.5A1.5 1.5 0 0 0 1.5 15h13a1.497 1.497 0 0 0 1.5-1.5"
    /></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna - https://github.com/tabler/tabler-icons/blob/master/LICENSE

https://icones.js.org/collection/all?s=regex&icon=tabler:regex
-->

{#snippet IconTablerRegex()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M6.5 15a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5M17 7.875l3-1.687m-3 1.687v3.375m0-3.375l-3-1.687m3 1.687l3 1.688M17 4.5v3.375m0 0l-3 1.688"
    /></svg
  >
{/snippet}

<!--
Icon from Lucide by Lucide Contributors - https://github.com/lucide-icons/lucide/blob/main/LICENSE

https://icones.js.org/collection/all?s=type&icon=lucide:type
-->
{#snippet IconLucideType()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M4 7V4h16v3M9 20h6M12 4v16"
    /></svg
  >
{/snippet}

<!--
Icon from Lucide by Lucide Contributors - https://github.com/lucide-icons/lucide/blob/main/LICENSE

https://icones.js.org/collection/all?s=replace-all&icon=lucide:replace-all
-->
{#snippet IconLucideReplaceAll()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
      ><path
        d="M14 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2m0-18a2 2 0 0 1 2-2m0 8a2 2 0 0 1-2-2m6 6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2m0-20a2 2 0 0 1 2 2m0 4a2 2 0 0 1-2 2M3 7l3 3l3-3"
      /><path d="M6 10V5a3 3 0 0 1 3-3h1" /><rect width="8" height="8" x="2" y="14" rx="2" /></g
    ></svg
  >
{/snippet}

<!--
Icon from Lucide by Lucide Contributors - https://github.com/lucide-icons/lucide/blob/main/LICENSE

https://icones.js.org/collection/all?s=replace-all&icon=lucide:replace
-->
{#snippet IconLucideReplace()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
      ><path d="M14 4a2 2 0 0 1 2-2m0 8a2 2 0 0 1-2-2m6-6a2 2 0 0 1 2 2m0 4a2 2 0 0 1-2 2M3 7l3 3l3-3" /><path
        d="M6 10V5a3 3 0 0 1 3-3h1"
      /><rect width="8" height="8" x="2" y="14" rx="2" /></g
    ></svg
  >
{/snippet}

<!--
Icon from Tabler Icons by Paweł Kuna - https://github.com/tabler/tabler-icons/blob/master/LICENSE
https://icones.js.org/collection/tabler?icon=tabler:home
-->
{#snippet IconTablerHome()}
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
    ><path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M5 12H3l9-9l9 9h-2M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7m-9 9v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6"
    /></svg
  >
{/snippet}

<!--
from grok.com
-->
{#snippet IconGrokIconDown()}
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke-width="2"
    class="size-3"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-linecap="square"></path></svg
  >
{/snippet}
